module.exports = __webpack_public_path__ + "img/csr_banner_01.8127f323.jpg";